export const SITE_COLORS = Object.freeze({
  flirt4free: '#2EA9D3',
  streamate: '#087DB8',
  livejasmin: '#BC0002',
  chaturbate: '#FF6B1A',
  stripchat: '#4EAD2D',
  kwiky: '#8A5FD1',
  sinparty: '#D83A9D',
  cams: '#8BCB3F',
  cam4: '#F4512A',
  bonga: '#C21846',
});

export const normalizeSiteColorKey = value => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]/g, '');

export const getSiteColor = value => SITE_COLORS[normalizeSiteColorKey(value)] || '#8796A5';
